import { IDirectionToSort, IKeyToSort, ISortFunction } from '../types';

import { isValidSemanticVersion, sortDate, sortVersionedValues } from './sortTagsSelect';

export const sortStrategies = (typeDirection: string): Record<IKeyToSort, ISortFunction> => {
  const isAsc = typeDirection === IDirectionToSort.ASC;

  return {
    [IKeyToSort.COUNT]: (a, b) => (isAsc ? a.count - b.count : b.count - a.count),
    [IKeyToSort.NUMBER]: (a, b) => {
      const valueA = a.value;
      const valueB = b.value;

      if (isValidSemanticVersion(valueA) && isValidSemanticVersion(valueB)) {
        return isAsc ? sortVersionedValues(valueA, valueB) : sortVersionedValues(valueB, valueA);
      }

      const numA = parseFloat(valueA);
      const numB = parseFloat(valueB);
      return isAsc ? numA - numB : numB - numA;
    },
    [IKeyToSort.ABC]: (a, b) => (isAsc ? a.value.localeCompare(b.value) : b.value.localeCompare(a.value)),
    [IKeyToSort.DATE]: (a, b) => (isAsc ? sortDate(a.value, b.value) : sortDate(b.value, a.value)),
  };
};
